// extracted by mini-css-extract-plugin
module.exports = {"nestedMsg":"styles_nestedMsg__4_qWU","container":"styles_container__HF_HV","scrollable":"styles_scrollable__pPR_w"};